export default __webpack_public_path__ + "assets/space_mining.18560a05.png";